import React from 'react';
import { Helmet } from 'react-helmet';
import Header from '../components/Header/header';
import FooterSection from '../components/Footer';

export default function NotFoundPage() {
  return (
    <>
      <Helmet>
        <title>Page Not Found | ExplorOFF</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <Header bgColor="teal" />
      <div style={{
        minHeight: '70vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        padding: '100px 24px 60px',
        gap: '16px',
      }}>
        <p style={{ fontSize: '5rem', fontWeight: '800', color: '#e0e6ed', lineHeight: 1, margin: 0 }}>404</p>
        <h1 style={{ fontSize: '1.8rem', fontWeight: '800', color: '#004858', margin: 0 }}>Trail Not Found</h1>
        <p style={{ color: '#555', fontSize: '1rem', maxWidth: '420px', margin: 0 }}>
          This page doesn't exist or has been moved. Try one of these instead:
        </p>
        <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap', justifyContent: 'center', marginTop: '8px' }}>
          <a href="/hiking-guides" style={{
            background: '#004858', color: '#fff', padding: '12px 24px',
            borderRadius: '6px', fontWeight: '700', textDecoration: 'none', fontSize: '0.95rem',
          }}>
            Hiking Guides
          </a>
          <a href="/itineraries" style={{
            border: '2px solid #004858', color: '#004858', padding: '10px 24px',
            borderRadius: '6px', fontWeight: '700', textDecoration: 'none', fontSize: '0.95rem',
          }}>
            Trip Itineraries
          </a>
          <a href="/" style={{
            border: '2px solid #e0e6ed', color: '#555', padding: '10px 24px',
            borderRadius: '6px', fontWeight: '700', textDecoration: 'none', fontSize: '0.95rem',
          }}>
            Home
          </a>
        </div>
      </div>
      <FooterSection />
    </>
  );
}
